import { values } from "lodash";

export const loginValidator = (value: any) => {
  const errors: any = {};

  if (!value.username) {
    errors.username = "Required";
  }
  return errors;
};
